import moment from 'moment';

export const isIterableArray = array => Array.isArray(array) && !!array.length;

export const getDuration = (startDate, endDate) => {
  if (!moment.isMoment(startDate)) throw new Error(`Start date must be a moment object, received ${typeof startDate}`);
  if (endDate && !moment.isMoment(endDate))
    throw new Error(`End date must be a moment object, received ${typeof startDate}`);

  return `${startDate.format('ll')} - ${endDate ? endDate.format('ll') : 'Present'} • ${startDate.from(
    endDate || moment(),
    true
  )}`;
};

export const hexToRgb = hexValue => {
  let hex;
  hexValue.indexOf('#') === 0 ? (hex = hexValue.substring(1)) : (hex = hexValue);
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
    hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b)
  );
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
};
export const rgbColor = (color = colors[0]) => `rgb(${hexToRgb(color)})`;
export const rgbaColor = (color = colors[0], alpha = 0.5) => `rgba(${hexToRgb(color)},${alpha})`;
export const colors = [
  '#2c7be5',
  '#00d97e',
  '#e63757',
  '#39afd1',
  '#fd7e14',
  '#02a8b5',
  '#727cf5',
  '#6b5eae',
  '#ff679b',
  '#f6c343'
];
export const rgbColors = colors.map(color => rgbColor(color));
export const rgbaColors = colors.map(color => rgbaColor(color));

export const downloadObject = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export function memorySizeOf(obj) {
  var bytes = 0;

  function sizeOf(obj) {
    if (obj !== null && obj !== undefined) {
      switch (typeof obj) {
        case 'number':
          bytes += 8;
          break;
        case 'string':
          bytes += obj.length * 2;
          break;
        case 'boolean':
          bytes += 4;
          break;
        case 'object':
          var objClass = Object.prototype.toString.call(obj).slice(8, -1);
          if (objClass === 'Object' || objClass === 'Array') {
            for (var key in obj) {
              if (!obj.hasOwnProperty(key)) continue;
              sizeOf(obj[key]);
            }
          } else bytes += obj.toString().length * 2;
          break;
        default:
          break;
      }
    }
    return bytes;
  }

  function formatByteSize(bytes) {
    if (bytes < 1024) return bytes + ' bytes';
    else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KiB';
    else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MiB';
    else return (bytes / 1073741824).toFixed(3) + ' GiB';
  }

  return formatByteSize(sizeOf(obj));
}

export const isEmailValid = email => {
  const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return regex.test(email);
};

export const isStringBlankOrNull = string => {
  if (string === null) {
    return true;
  }

  if (typeof string === 'string' && string.trim() === '') {
    return true;
  }
  return false;
};

export const getObjectArraySortedByProperty = (array, property) => {
  try {
    return array.sort((a, b) => b[property] - a[property]);
  } catch (e) {
    return array;
  }
};

export const getUniqueObjectsByProperty = (array, property) => {
  try {
    const existingObjects = {};
    const finalArray = [];

    for (let i = 0; i < array.length; i++) {
      const object = array[i];
      if (!existingObjects[object[property]]) {
        finalArray.push(object);
        existingObjects[object[property]] = true;
      }
    }

    return finalArray;
  } catch (e) {
    return array;
  }
};

export const getCopyOfObjectContents = object => {
  if (object && typeof object === 'object') {
    return JSON.parse(JSON.stringify(object));
  } else {
    return null;
  }
};

export const openLinkInNewTab = url => {
  const newTab = window.open(url, '_blank');
  newTab && newTab.focus();
};

/*
 * Send the browser to a stored file it is meant to keep.
 *
 * Not a new tab: a pop-up is only allowed for a moment after a click, and building
 * an archive can take longer than that, so the download was silently blocked. The
 * archives are stored as attachments, so following the link downloads them without
 * ever leaving the page.
 */
// react-select styles every select in the app starts from
export const selectTargetStyles = {
  // the chip's remove cross is a pointer target; react-select draws it 22 px wide (WCAG 2.5.8 asks for 24)
  multiValueRemove: provided => ({ ...provided, minWidth: 24, justifyContent: 'center' })
};

export const downloadFileFromUrl = url => {
  const link = document.createElement('a');
  link.href = url;
  link.rel = 'noopener';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getBlobFromBase64 = (base64Content, contentType) => {
  const binary = window.atob(base64Content);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new Blob([bytes], { type: contentType });
};
